import { useState } from "react";
import { Phone, CircleCheck as CheckCircle2, ShieldCheck, Star, ArrowRight, TriangleAlert as AlertTriangle } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { FormProvider } from "@/integrations/forms/FormProvider";
const HERO_IMG = {
  desktop: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/9ada9b93-909d-463a-a8f5-c673b2a6de54.png",
  tablet: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/9ada9b93-909d-463a-a8f5-c673b2a6de54.png",
  mobile: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/9ada9b93-909d-463a-a8f5-c673b2a6de54.png"
};
const NAVY = "#081438";
const GOLD = "#F5A623";
const FONT_HEAD = "'Plus Jakarta Sans', system-ui, sans-serif";
const FONT_BODY = "'Manrope', system-ui, sans-serif";
export default function CableHero() {
  const formFooterItems = [{
    text: "Free Inspection"
  }, {
    text: "Fast Response"
  }, {
    text: "Licensed Techs"
  }];
  return <section className="relative isolate overflow-hidden !bg-[url(https://goldgaragedoor.com.au/wp-content/uploads/2026/06/repair-hero-desktop.webp)]" style={{
    background: NAVY,
    minHeight: "100vh",
    paddingTop: "120px",
    paddingBottom: "80px",
    fontFamily: FONT_BODY
  }}>
      {}
      <picture>
        <source media="(max-width: 640px)" srcSet={HERO_IMG.mobile} />
        <source media="(max-width: 1024px)" srcSet={HERO_IMG.tablet} />
        <img src={HERO_IMG.desktop} alt="" aria-hidden="true" loading="eager" decoding="async" style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        opacity: 0.35,
        zIndex: 0
      }} />
      </picture>

      {/* navy overlay sits in front of (on top of) the image */}
      <div style={{
      position: "absolute",
      inset: 0,
      background: `linear-gradient(135deg, ${NAVY} 0%, rgba(8,20,56,0.85) 50%, rgba(8,20,56,0.95) 100%)`,
      zIndex: 1
    }} />

      {}
      <div style={{
      position: "absolute",
      inset: 0,
      opacity: 0.04,
      mixBlendMode: "overlay",
      zIndex: 2,
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Cfilter id='n'%3E%3CfeTurbulence baseFrequency='0.9'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E\")",
      pointerEvents: "none"
    }} />

      {}
      <div style={{
      position: "absolute",
      top: 120,
      left: 0,
      width: 4,
      height: 80,
      background: GOLD,
      zIndex: 3
    }} />

      <div style={{
      position: "relative",
      zIndex: 4,
      maxWidth: 1280,
      margin: "0 auto",
      padding: "0 24px",
      display: "grid",
      gridTemplateColumns: "minmax(0, 1.1fr) minmax(0, 0.9fr)",
      gap: 56,
      alignItems: "center"
    }} className="cable-hero-grid">
        {}
        <div>
          {}
          <div style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 10,
          padding: "8px 16px",
          background: "rgba(245,166,35,0.1)",
          border: "1px solid rgba(245,166,35,0.3)",
          borderRadius: 100,
          marginBottom: 28
        }}>
            <AlertTriangle size={14} color={GOLD} strokeWidth={2.5} />
            <span style={{
            fontFamily: FONT_BODY,
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            color: GOLD
          }}>
              Snapped Cable · Safety Hazard · Sydney
            </span>
          </div>

          {}
          <h1 style={{
          fontFamily: FONT_HEAD,
          fontSize: "clamp(36px, 5.5vw, 64px)",
          fontWeight: 800,
          color: "#ffffff",
          lineHeight: 1.02,
          letterSpacing: "-0.025em",
          margin: "0 0 24px"
        }}>
            Snapped Cable?{" "}
            <span style={{
            background: `linear-gradient(135deg, ${GOLD} 0%, #D4A63A 100%)`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            display: "inline-block",
            fontStyle: "italic"
          }}>
              Don't lift the door.
            </span>
            <br />
            We'll fix it today.
          </h1>

          {}
          <p style={{
          fontFamily: FONT_BODY,
          fontSize: "clamp(16px, 1.4vw, 19px)",
          color: "rgba(255,255,255,0.78)",
          lineHeight: 1.6,
          maxWidth: 560,
          margin: "0 0 36px"
        }}>
            A broken cable is a serious safety risk — the door can drop or
            jam violently. Our licensed technicians replace both cables (always
            in pairs) with same-day callouts across Sydney. Fixed price. 12-month
            warranty.
          </p>

          {}
          <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 24,
          marginBottom: 40
        }}>
            {[{
            Icon: Star,
            text: "5.0  Google rated"
          }, {
            Icon: ShieldCheck,
            text: "Licensed & insured"
          }, {
            Icon: CheckCircle2,
            text: "Same-day repair"
          }].map(({
            Icon,
            text
          }, i) => <div key={i} style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            color: "rgba(255,255,255,0.85)",
            fontSize: 14,
            fontWeight: 500,
            fontFamily: FONT_BODY
          }}>
                <Icon size={18} color={GOLD} strokeWidth={2} />
                {text}
              </div>)}
          </div>

          {}
          <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 14
        }}>
            <Link to="tel:0485000933" style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            padding: "16px 28px",
            background: GOLD,
            color: NAVY,
            fontFamily: FONT_HEAD,
            fontSize: 16,
            fontWeight: 700,
            borderRadius: 12,
            textDecoration: "none",
            transition: "transform 0.2s, box-shadow 0.2s",
            boxShadow: "0 8px 24px rgba(245,166,35,0.3)"
          }} onMouseEnter={e => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 12px 32px rgba(245,166,35,0.45)";
          }} onMouseLeave={e => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 8px 24px rgba(245,166,35,0.3)";
          }}>
              <Phone size={18} strokeWidth={2.5} />
              0485 000 933
            </Link>
            <Link to="#contact-us" style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            padding: "16px 28px",
            background: "transparent",
            color: "#ffffff",
            fontFamily: FONT_HEAD,
            fontSize: 16,
            fontWeight: 600,
            borderRadius: 12,
            textDecoration: "none",
            border: "1px solid rgba(255,255,255,0.25)",
            transition: "background 0.2s, border-color 0.2s"
          }} onMouseEnter={e => {
            (e.currentTarget as HTMLAnchorElement).style.background = "rgba(255,255,255,0.08)";
            (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(255,255,255,0.4)";
          }} onMouseLeave={e => {
            (e.currentTarget as HTMLAnchorElement).style.background = "transparent";
            (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(255,255,255,0.25)";
          }}>
              Get Free Quote
              <ArrowRight size={16} strokeWidth={2.5} />
            </Link>
          </div>
        </div>

        {}
        <div id="contact-us" className="relative bg-white backdrop-blur-sm p-6 md:p-8 rounded-lg border border-[#F5A623]/40 shadow-2xl shadow-[#081438]/10 overflow-hidden scroll-mt-28">
          <div className="absolute inset-0 opacity-[0.015] bg-[url('data:image/svg+xml,%3Csvg%20width=%22100%22%20height=%22100%22%20xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cpath%20d=%22M0%200h100v100H0z%22%20fill=%22%23081438%22/%3E%3C/svg%3E')] pointer-events-none rounded-lg" />
          <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#F5A623] via-[#ffc142] to-[#F5A623]" />
          
          <div className="text-center mb-6 relative z-10">
            <h2 className="text-xl font-bold text-[#081438] mb-1.5">Get Your Free Quote</h2>
            <p className="text-[13.5px] text-[#555] font-medium">Fast response · No obligation · No hidden fees</p>
            <div className="h-px bg-gradient-to-r from-transparent via-[#F5A623]/20 to-transparent my-4" />
          </div>

          <div className="space-y-4 relative z-10">
            <FormProvider formId="hero_quote_form" sectionName="Hero Section" defaultValues={{
            name: "",
            phone: "",
            suburb: "",
            service: ""
          }} successMessage="Thank you! Your quote request has been sent.">
              <div className="space-y-3">
                <input type="text" placeholder="Your Name" className="w-full px-4 py-2.5 border border-gray-200 rounded-lg text-[14px] font-medium text-gray-900 placeholder-gray-500 focus:outline-none focus:border-[#F5A623]" />
                <input type="tel" placeholder="Your Phone" className="w-full px-4 py-2.5 border border-gray-200 rounded-lg text-[14px] font-medium text-gray-900 placeholder-gray-500 focus:outline-none focus:border-[#F5A623]" />
                <input type="text" placeholder="Your Suburb" className="w-full px-4 py-2.5 border border-gray-200 rounded-lg text-[14px] font-medium text-gray-900 placeholder-gray-500 focus:outline-none focus:border-[#F5A623]" />
                <button type="submit" className="w-full px-4 py-2.5 bg-[#F5A623] text-[#081438] rounded-lg font-bold text-[14px] transition hover:bg-[#D4A63A]">Get Free Quote</button>
              </div>
            </FormProvider>
          </div>

          <div className="mt-6 pt-4 border-t border-black/5 flex justify-center gap-5 relative z-10">
            {formFooterItems.map((item, i) => <div key={i} data-index={i} className="flex items-center gap-1.5">
                <span className="text-[12px] font-semibold text-[#333]">{item.text}</span>
              </div>)}
          </div>
        </div>
      </div>

      {}
      <style>{`
        @media (max-width: 960px) {
          .cable-hero-grid {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
          }
        }
      `}</style>
    </section>;
}